(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('account', {
                abstract: true,
                parent: 'app'
            });
        });

})();
